import { render, staticRenderFns } from "./order-form-property-weight.vue?vue&type=template&id=185a3d48"
import script from "./order-form-property-weight.vue?vue&type=script&lang=js"
export * from "./order-form-property-weight.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-weight.vue?vue&type=style&index=0&id=185a3d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports